
import { API } from './api'

export function hasTokenAvailable () {
  const authToken = getAccessToken()
  if (authToken) {
    setUpAxiosAuthHeaders(authToken)
    return true
  }
  return false
}

export function getAccessToken () {
  if (process.env.TEST_API || process.env.TEST) { return }

  const items = { ...window.localStorage }
  for (const item in items) {
    if (/CognitoIdentityServiceProvider\..*\.accessToken/.test(item)) { return items[item] }
  }
  return false
}

export function setUpAxiosAuthHeaders (authToken) {
  if (process.env.TEST_API || authToken === undefined) { return }
  API.axios.defaults.headers.Authorization = authToken
  API.logged = true
}
